<template>
  <div>
    <BaseTheAccordeonItem
      v-for="(item, index) in data"
      :key="item.title"
      ref="accordeonItems"
      class="scroll-margin-title mb-5 last:mb-0"
      :data="item"
      :index="index"
      :icons="icons"
      :segment="segment"
      :active-chapter="activeChapter"
      :active-chapters="activeChapters"
      :active-highlight="activeHighlight"
      @on-expanded="handleExpanded"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: [Array, Object],
    required: true,
  },
  activeChapter: {
    type: Number,
    default: null,
  },
  activeChapters: {
    type: Array,
    default: () => [],
  },
  activeHighlight: {
    type: String,
    default: null,
  },
  segment: {
    type: String,
    required: true,
  },
  icons: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['on-active']);

const route = useRoute();

const accordeonItems = ref(null);

watch(
  () => props.activeChapter,
  async (value) => {
    if (value === null) return;
    await new Promise((resolve) => setTimeout(resolve, 500));

    if (route.query?.category) {
      const item =
        accordeonItems.value[value].$el.querySelector('.active-content');
      if (!item) return;
      item.scrollIntoView({
        behavior: 'smooth',
      });

      return;
    }
    accordeonItems.value[value]?.$el.scrollIntoView({
      behavior: 'smooth',
    });
  },
);

const handleExpanded = (e) => {
  emit('on-active', e);
};
</script>
